import axios from 'axios'
import store from 'store'
import { message, notification } from 'antd'
import { history } from 'index'

const { href: host } = window.location
export const isLocalEnvironment = host.includes('localhost') || host.includes('surge')
const apiClient = axios.create({
  //  baseURL: 'https://ziapi.techend.com.ng/api/admin/',
  baseURL:
    host.includes('localhost') || host.includes('surge')
      ? 'https://api.zimcserver.com/zero-api/public/api/admin'
      : 'https://ziapi.techend.com.ng/api/admin/',

  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

apiClient.interceptors.request.use(request => {
  const accessToken = store.get('accessToken')
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AccessToken = accessToken
  }
  return request
})

apiClient.interceptors.response.use(undefined, error => {
  // Errors handling
  const { response, config } = error
  const { data } = response || { data: '' }
  const error401 = JSON.stringify(error).includes('401')
  if (error401) {
    history.push('/auth/login')
    store.clearAll()
    message.error({
      content: 'Token has expired, please re-login to continue.',
      duration: 4,
      key: 'updatable',
    })
    return Promise.reject(error)
  }

  // Handle 404 gracefully if ignore404 is configured or for yearly-subscription status
  const is404 = response?.status === 404 || JSON.stringify(error).includes('404')
  const shouldIgnore404 = config?.ignore404 || config?.url?.includes('yearly-subscription/status')
  if (shouldIgnore404 && is404) {
    return Promise.resolve({
      status: 404,
      data: { status: false, data: null, message: 'No active subscription' },
    })
  }

  notification.error({
    message: 'Error!',
    description: String(error),
  })

  if (data) {
    const warningMsg =
      typeof data === 'string'
        ? data
        : data?.message ||
          data?.error ||
          (typeof data === 'object' ? JSON.stringify(data) : String(data))
    notification.warning({
      message: warningMsg,
    })
  }

  return Promise.reject(error) // Ensure a value is returned at the end
})

export const formatCurrency1 = num => {
  if (num !== undefined) {
    return parseFloat(Number(num).toFixed(2))
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
  return 0
}

export const formatCurrency = value =>
  new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
  }).format(value || 0)

// export const formatDate = (input) => {
//     if (!input) return null;

//     // Try native Date parsing
//     const parsed = new Date(input);

//     if (!Number.isNaN(parsed.getTime())) {
//       return parsed.toISOString().split('T')[0]; // YYYY-MM-DD
//     }

//     // Handle "30 Sep 2025" manually
//     const parts = input.split(' ');
//     if (parts.length === 3) {
//       const [day, monthStr, year] = parts;

//       const months = {
//         Jan: '01', Feb: '02', Mar: '03', Apr: '04',
//         May: '05', Jun: '06', Jul: '07', Aug: '08',
//         Sep: '09', Oct: '10', Nov: '11', Dec: '12'
//       };

//       const month = months[monthStr];

//       if (month) {
//         return `${year}-${month}-${day.padStart(2, '0')}`;
//       }
//     }

//     return null; // fallback
// };
export const formatDate = input => {
  if (!input) return null

  // Try native Date parsing
  const parsed = new Date(input)

  if (!Number.isNaN(parsed.getTime())) {
    const year = parsed.getFullYear()
    const month = String(parsed.getMonth() + 1).padStart(2, '0')
    const day = String(parsed.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}` // ✅ LOCAL date (no timezone shift)
  }

  // Handle "30 Sep 2025" manually
  const parts = input.split(' ')
  if (parts.length === 3) {
    const [day, monthStr, year] = parts

    const months = {
      Jan: '01',
      Feb: '02',
      Mar: '03',
      Apr: '04',
      May: '05',
      Jun: '06',
      Jul: '07',
      Aug: '08',
      Sep: '09',
      Oct: '10',
      Nov: '11',
      Dec: '12',
    }

    const month = months[monthStr]

    if (month) {
      return `${year}-${month}-${day.padStart(2, '0')}`
    }
  }

  return null
}

export const numberFormat = value =>
  new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
  }).format(value || 0)

export default apiClient
